import Link from '@mui/material/Link';
import Typography, { TypographyProps } from '@mui/material/Typography';

export default function Copyright(props: TypographyProps<'span'>) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://timeontrails.com/">
        Time on Trails
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}